<template>
	<div>
		<h1>
			Contributions (<a
				style="color: #52699a;"
				href="https://credit.niso.org/"
				target="_blank"
				title="Contributor Roles Taxonomy(CRediT)"
				>CRediT</a
			>)
		</h1>
		<InputConSelectMulti
			v-for="(author, index) in this.$tera.project.author"
			:key="index"
			:question="ackAuthor(author)"
			v-model="$tera.project.conAuthors"
			:contributors="$tera.project.author"
			:index="index"
			:author="author"
			:options="contributionOptions"
			:questionMark="genMark(index)"
		/>
		<BasePreviewOutput
			:component="outputComponent"
			:contributionOptions="contributionOptions"
		/>
	</div>
</template>
<script>
import InputConSelectMulti from "@/components/InputConSelectMulti";
import BasePreviewOutput from "@/components/BasePreviewOutput.vue";
import OutputContributions from "./OutputContributions.vue";
export default {
	name: "ViewMethodContributions",
	components: {
		InputConSelectMulti,
		BasePreviewOutput
	},
	data() {
		return {
			outputComponent: OutputContributions,
			contributionOptions: [
				{ label: "Conceptualization" },
				{ label: "Data curation" },
				{ label: "Formal analysis" },
				{ label: "Funding acquisition" },
				{ label: "Investigation" },
				{ label: "Methodology" },
				{ label: "Project administration" },
				{ label: "Resources" },
				{ label: "Software" },
				{ label: "Supervision" },
				{ label: "Validation" },
				{ label: "Visualization" },
				{ label: "Writing - original draft" },
				{ label: "Writing - review & editing" }
			]
		};
	},
	methods: {
		ackAuthor(author) {
			return "What were the contributions of " + author + "?";
		},
		genMark(index) {
			//console.log(index)
			return `writeprotocol-` + index + 4;
		}
	}
};
</script>
<style></style>
